<template>
    <div class="experience">
        <div class="container">
            <div class="years">
                <div class="year scroll-animated scale">
                    <h4>1</h4>
                    <span>2011</span>
                    <div class="year-detail english" v-if="this.english">
                        <h5>Envato Inc.</h5>
                        <span>Frontend Developer</span>
                        <p>Collaborate with creative and development teams on the execution of ideas.</p>
                    </div>
                    <div class="year-detail arabic" v-if="this.arabic">
                        <h5>شركة جوجل</h5>
                        <span>مطور واجهات أمامية</span>
                        <p>مراقبة الجوانب الفنية لتطوير الواجهات الأمامية للمشاريع</p>
                    </div>
                </div>
                <div class="year scroll-animated scale">
                    <h4>2</h4>
                    <span>2018</span>
                    <div class="year-detail english" v-if="this.english">
                        <h5>Envato Inc.</h5>
                        <span>Frontend Developer</span>
                        <p>Collaborate with creative and development teams on the execution of ideas.</p>
                    </div>
                    <div class="year-detail arabic" v-if="this.arabic">
                        <h5>شركة جوجل</h5>
                        <span>مطور واجهات أمامية</span>
                        <p>مراقبة الجوانب الفنية لتطوير الواجهات الأمامية للمشاريع</p>
                    </div>
                </div>
                <div class="year scroll-animated scale">
                    <h4>3</h4>
                    <span>2019</span>
                    <div class="year-detail english" v-if="this.english">
                        <h5>Envato Inc.</h5>
                        <span>Frontend Developer</span>
                        <p>Collaborate with creative and development teams on the execution of ideas.</p>
                    </div>
                    <div class="year-detail arabic" v-if="this.arabic">
                        <h5>شركة جوجل</h5>
                        <span>مطور واجهات أمامية</span>
                        <p>مراقبة الجوانب الفنية لتطوير الواجهات الأمامية للمشاريع</p>
                    </div>
                </div>
                <div class="year scroll-animated scale">
                    <h4>4</h4>
                    <span>2020</span>
                    <div class="year-detail english" v-if="this.english">
                        <h5>Envato Inc.</h5>
                        <span>Frontend Developer</span>
                        <p>Collaborate with creative and development teams on the execution of ideas.</p>
                    </div>
                    <div class="year-detail arabic" v-if="this.arabic">
                        <h5>شركة جوجل</h5>
                        <span>مطور واجهات أمامية</span>
                        <p>مراقبة الجوانب الفنية لتطوير الواجهات الأمامية للمشاريع</p>
                    </div>
                </div>
                <div class="year scroll-animated scale">
                    <h4>5</h4>
                    <span>2021</span>
                    <div class="year-detail english" v-if="this.english">
                        <h5>Envato Inc.</h5>
                        <span>Frontend Developer</span>
                        <p>Collaborate with creative and development teams on the execution of ideas.</p>
                    </div>
                    <div class="year-detail arabic" v-if="this.arabic">
                        <h5>شركة جوجل</h5>
                        <span>مطور واجهات أمامية</span>
                        <p>مراقبة الجوانب الفنية لتطوير الواجهات الأمامية للمشاريع</p>
                    </div>
                </div>
                <div class="year scroll-animated scale">
                    <h4>6</h4>
                    <span>2021</span>
                    <div class="year-detail english" v-if="this.english">
                        <h5>Envato Inc.</h5>
                        <span>Frontend Developer</span>
                        <p>Collaborate with creative and development teams on the execution of ideas.</p>
                    </div>
                    <div class="year-detail arabic" v-if="this.arabic">
                        <h5>شركة جوجل</h5>
                        <span>مطور واجهات أمامية</span>
                        <p>مراقبة الجوانب الفنية لتطوير الواجهات الأمامية للمشاريع</p>
                    </div>
                </div>
                <div class="year scroll-animated scale">
                    <h4>7</h4>
                    <span>2022</span>
                    <div class="year-detail english" v-if="this.english">
                        <h5>Envato Inc.</h5>
                        <span>Frontend Developer</span>
                        <p>Collaborate with creative and development teams on the execution of ideas.</p>
                    </div>
                    <div class="year-detail arabic" v-if="this.arabic">
                        <h5>شركة جوجل</h5>
                        <span>مطور واجهات أمامية</span>
                        <p>مراقبة الجوانب الفنية لتطوير الواجهات الأمامية للمشاريع</p>
                    </div>
                </div>
                <div class="year scroll-animated scale">
                    <h4>8</h4>
                    <span>2022</span>
                    <div class="year-detail english" v-if="this.english">
                        <h5>Envato Inc.</h5>
                        <span>Frontend Developer</span>
                        <p>Collaborate with creative and development teams on the execution of ideas.</p>
                    </div>
                    <div class="year-detail arabic" v-if="this.arabic">
                        <h5>شركة جوجل</h5>
                        <span>مطور واجهات أمامية</span>
                        <p>مراقبة الجوانب الفنية لتطوير الواجهات الأمامية للمشاريع</p>
                    </div>
                </div>
                <div class="year scroll-animated scale">
                    <h4>9</h4>
                    <span>2023</span>
                    <div class="year-detail english" v-if="this.english">
                        <h5>Envato Inc.</h5>
                        <span>Frontend Developer</span>
                        <p>Collaborate with creative and development teams on the execution of ideas.</p>
                    </div>
                    <div class="year-detail arabic" v-if="this.arabic">
                        <h5>شركة جوجل</h5>
                        <span>مطور واجهات أمامية</span>
                        <p>مراقبة الجوانب الفنية لتطوير الواجهات الأمامية للمشاريع</p>
                    </div>
                </div>
            </div>
            <div class="text">
                <div class="main-text">
                    <div class="main-heading scroll-animated scale">
                        <h4 class="english" v-if="this.english">EXPERIENCE</h4>
                        <h4 class="arabic" v-if="this.arabic">خبراتي</h4>
                    </div>
                    <h2 class="scroll-animated translate english" v-if="this.english">2+ Years of Experience With Many Awards!</h2>
                    <h2 class="scroll-animated translate arabic" v-if="this.arabic">2+ سنة من الخبرة مع العديد من الجوائز!</h2>
                    <p class="scroll-animated translate english" v-if="this.english">I have been developing sites and apps for 12 years and i know for sure the main trends and directions of modern design, I have been a visionary and a reliable software engineering partner for world-class brands. You will get a decent result as you expect.</p>
                    <p class="scroll-animated translate arabic" v-if="this.arabic">لقد عملت على تطوير المواقع والتطبيقات لمدة عامين وأنا بالتأكيد أعلم الاتجاهات والمفاهيم الحديثة لتطوير الويب ، لقد كنت شريكًا ذا رؤية وموثوقًا بهندسة البرمجيات للكثير من العلامات التجارية العالمية. سوف تحصل على نتيجة جيدة كما تتوقع.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:"Experience",
        props:["english","arabic"],
        mounted(){
            document.querySelectorAll(".year .year-detail").forEach((detail) => {
                detail.style.cssText = `
                    opacity: 0;
                    display: none;
                `
            })
            document.querySelectorAll(".year").forEach((year,index) => {
                year.addEventListener("mouseover",() => {
                    document.querySelectorAll(".year .year-detail")[index].style.display = "block"
                    setTimeout(() => {
                        document.querySelectorAll(".year .year-detail")[index].style.opacity = "1"
                    }, 50);
                })
                year.addEventListener("mouseleave",() => {
                    document.querySelectorAll(".year .year-detail")[index].style.opacity = "0"
                    setTimeout(() => {
                        document.querySelectorAll(".year .year-detail")[index].style.display = "none"
                    }, 50);
                })
            })
        }
    }
</script>

<style scoped>
.experience{
    padding-top: 100px;
    padding-bottom: 100px;
}
.experience .container{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.experience .container > *{
    width: 50%;
}
.experience .container .years{
    display: grid;
    grid-template-columns: repeat(3,1fr);
    grid-template-rows: repeat(3,1fr);
    gap: 30px;
    padding-left: 30px;
    padding-right: 30px;
}
.experience .container .years .year{
    display: flex;
    align-items: center;
    position: relative;
}
.experience .container .years .year .year-detail{
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate(-60%,-110%);
    background-color: var(--lighter-color);
    width: 250px;
    text-align: center;
    padding: 20px;
    box-shadow: 0px 0px 10px 0px rgb(15, 15, 15);
    border-radius: 10px;
    /* opacity: 0; */
    transition: opacity 0.2s 1s linear;
    transition-duration: 0.3s;
    /* display: none; */
    z-index: -1;
}
.experience .container .years .year > span{
    z-index: 4;
}
.experience .container .years .year > span:hover + .year-detail{
    opacity: 1;
    z-index: 2;
    display: block;
}
.experience .container .years .year .year-detail::before{
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%,100%);
    border-width: 10px;
    border-style: solid;
    border-color: var(--lighter-color) transparent transparent transparent;
}
.experience .container .years .year .year-detail h5{
    font-size: 18px;
    color: var(--sec-color);
    font-weight: 800;
    margin-bottom: 5px;
}
.experience .container .years .year .year-detail span{
    font-weight: bold;
}
.experience .container .years .year .year-detail p{
    margin-top: 20px;
    color: var(--sec-text-color);
    line-height: 1.4;
}
.experience .container .years .year h4{
    background-color: var(--sec-color);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    z-index: 2;
}
.experience .container .years .year > span{
    background-color: var(--lighter-color);
    padding: 5px 15px 5px 30px;
    border-radius: 10px;
    transform: translateX(-20px);
    z-index: 1;
    font-weight: bold;
    box-shadow: 0px 0px 10px 0px rgb(15, 15, 15);
}
.experience .container .years .year.arabized{
    flex-direction: row-reverse;
    justify-content: center;
}
.experience .container .text .main-heading{
  transform: rotateZ(90deg) translateY(200%) translateX(50%);
}
.experience .container .text .main-heading.arabized{
    transform: rotateZ(90deg) translateY(-58%) translateX(34%);
}
@media (max-width:992px) {
    .experience .container{
        flex-direction: column;
        gap: 50px;
    }
    .experience .container > *{
        width: 100%;
    }
}
@media (max-width:767px) {
    .experience .container .years{
        grid-template-columns: repeat(2,1fr);
        grid-template-rows: repeat(4,1fr);
        place-items: center;
    }
    .experience .container .years .year:nth-child(1) .year-detail,
    .experience .container .years .year:nth-child(3) .year-detail,
    .experience .container .years .year:nth-child(5) .year-detail,
    .experience .container .years .year:nth-child(7) .year-detail,
    .experience .container .years .year:nth-child(9) .year-detail{
        transform: translate(-40%,-110%);
    }
}
</style>